import React, { useState, useEffect } from 'react';
import Icon from '@legacy-vfuk/core-icon';
import {
  IconLinkWrapper,
  IconLinksContainer,
  TextWrapper,
} from './styles/SectionIconLinkBar.styles';
import { ISectionIconLinkBar } from './types/SectionIconLinkBar.types';

const SectionIconLinkBar = ({ data }: ISectionIconLinkBar) => {
  const [pageTitle, setPageTitle] = useState('');
  const { icons } = data;
  const iconLinks = icons.map(icon => (
    <IconLinkWrapper
      key={icon.id}
      href={icon.url}
      title={icon.label}
      data-analytics-element={icon.label}
      data-analytics-category="Link"
      data-analytics-context={pageTitle}
    >
      <Icon
        name={icon.iconRef}
        inverse={icon.inverse}
        appearance={icon.appearance || "primary"}
        size={icon.iconSize}
      />
      <TextWrapper>{icon.label}</TextWrapper>
    </IconLinkWrapper>
  ));

  // pageTitle implemented for SEO, timeout in place for a previous loading bug - may need reviewing
  useEffect(() => {
    setTimeout(() => {
      setPageTitle(document.title);
    }, 500);
  }, []);

  return (
    <IconLinksContainer data-id="iconLinkBar">{iconLinks}</IconLinksContainer>
  );
};

export default SectionIconLinkBar;
